export default __webpack_public_path__ + "static/media/17.ae57e0ad.jpg";